import { render } from "./QuotationPreview.vue?vue&type=template&id=6f0e8058&scoped=true"
import script from "./QuotationPreview.vue?vue&type=script&lang=js"
export * from "./QuotationPreview.vue?vue&type=script&lang=js"

import "./QuotationPreview.vue?vue&type=style&index=0&id=6f0e8058&scoped=true&lang=css"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6f0e8058"]])

export default __exports__